import { system } from './system'

const resolveValue = (path: string, seen: Set<string>): string | undefined => {
  if (seen.has(path)) {
    throw new Error(`[dark] Circular token reference: ${path}`)
  }
  seen.add(path)
  const token = system.tokens.getByName(path)
  const value = token?.originalValue ?? token?.value
  if (typeof value !== 'string') return undefined
  const reference = value.match(/^\{(.+)\}$/)
  if (reference) return resolveValue(reference[1], seen)
  return value.startsWith('var(') ? undefined : value
}

/**
 * CSS var reference for a theme token with its resolved value as the inline
 * fallback, e.g. tokenVar('colors.bg.input') →
 * 'var(--hw-dark-colors-bg-input, #092738)'. The var name comes from the
 * system's cssVarsPrefix; the fallback keeps styles rendered outside
 * DarkProvider (react-select portals, SVG attributes) on design-library
 * values.
 */
export const tokenVar = (path: string): string => {
  const token = system.tokens.getByName(path)
  const cssVar = token?.extensions.cssVar
  if (!cssVar) {
    throw new Error(`[dark] Unknown theme token: ${path}`)
  }
  const fallback = resolveValue(path, new Set())
  return fallback ? `var(${cssVar.var}, ${fallback})` : cssVar.ref
}
